(() => {
  function initCollection(root) {
    if (!root || root.dataset.pvPlpReady) return;
    root.dataset.pvPlpReady = 'true';

    const sectionId = root.dataset.sectionId;

    const sort = root.querySelector('[data-pv-plp-sort]');
    sort?.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    const drawer = root.querySelector('[data-pv-plp-drawer]');
    const opener = root.querySelector('[data-pv-plp-open]');
    let lastFocus = null;

    const openDrawer = () => {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      opener?.setAttribute('aria-expanded', 'true');
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      drawer.querySelector('.pv-ord-plp__close')?.focus();
    };

    const closeDrawer = () => {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      opener?.setAttribute('aria-expanded', 'false');
      setTimeout(() => {
        drawer.hidden = true;
        (lastFocus && lastFocus !== document.body ? lastFocus : opener)?.focus();
      }, 300);
    };

    opener?.addEventListener('click', openDrawer);
    drawer?.querySelectorAll('[data-pv-plp-close]').forEach((el) => el.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
    });

    root.querySelectorAll('[data-pv-plp-filters]').forEach((form) => {
      form.addEventListener('submit', () => {
        [...form.elements].forEach((field) => {
          if (field.type === 'number' && field.value === '') field.disabled = true;
        });
      });
    });

    root.addEventListener('click', async (event) => {
      const more = event.target.closest('[data-pv-plp-more]');
      if (!more) return;
      event.preventDefault();
      more.classList.add('is-loading');

      try {
        const url = new URL(more.href, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        const html = await (await fetch(url.toString())).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = root.querySelector('[data-pv-plp-grid]');
        doc.querySelectorAll('[data-pv-plp-grid] > li').forEach((item) => grid.append(item));
        window.PvOrdinaryMotion?.refresh(root);

        const nextWrap = doc.querySelector('[data-pv-plp-more-wrap]');
        const wrap = root.querySelector('[data-pv-plp-more-wrap]');
        if (nextWrap && wrap) wrap.replaceWith(nextWrap);
      } catch (error) {
        window.location.href = more.href;
      }
    });
  }

  document.querySelectorAll('[data-pv-plp]').forEach(initCollection);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-pv-plp]').forEach(initCollection);
  });
})();
